<template>
  <v-layout row>
    <v-flex xs12 sm8 offset-sm2 lg4 offset-lg4>
      <form @submit.prevent="register" @keydown="form.onKeydown($event)">
        <v-card round flat>
          <progress-bar :show="form.busy"></progress-bar>
          <v-card-title primary-title>
            <div class="form-title">
              <img src="/img/acma3.jpg" alt="alt" width="250" height="88" />
              <h3 class="title text-uppercase primary--text mb-0">
                Création de compte
              </h3>
            </div>
          </v-card-title>
          <v-card-text class="">
            <v-layout row wrap mx-2 px-2>
              <v-flex xs12>
                <v-tabs centered v-model="tab">
                  <v-tab-item>
                    <!-- Last Name -->
                    <div class="form-field">
                      <label for="">Nom</label>
                      <v-text-field v-model="form.last_name" placeholder="Ex. Hugues" solo name="last_name"
                        v-validate="'required'" :error-messages="errors.collect('last_name')"
                        data-vv-name="last_name"></v-text-field>
                    </div>

                    <!-- FirstName -->
                    <div class="form-field">
                      <label for="">Prénom</label>
                      <v-text-field v-model="form.first_name" placeholder="Ex. SATO" solo name="first_name"
                        v-validate="'required'" :error-messages="errors.collect('first_name')"
                        data-vv-name="first_name"></v-text-field>
                    </div>

                    <div class="form-field">
                      <label>Nom d'utilisateur</label>
                      <v-text-field v-model="form.username" placeholder="Ex. huguesato3" solo counter="30"
                        name="username" v-validate="'required|max:30'" :error-messages="errors.collect('username')"
                        data-vv-name="username"></v-text-field>
                    </div>

                    <div class="form-field">
                      <label for="">Téléphone</label>
                      <v-text-field v-model="form.phone" placeholder="Ex. 67292729" name="phone" solo
                        data-vv-name="phone" v-validate="'required'"
                        :error-messages="errors.collect('phone')"></v-text-field>
                    </div>

                    <div class="form-field">
                      <label for="">Adresse mail
                        <i class="grey--text">(lecture seule)</i></label>
                      <v-text-field v-model="form.email" placeholder="Ex: huguesato@gmail.com" name="email" solo
                        readonly v-validate="'required|email'" data-vv-name="email"
                        :error-messages="errors.collect('email')"></v-text-field>
                    </div>
                    <div class="form-field">
                      <label for="">Domaines</label>
                      <v-select v-model="form.domain_id" :items="domains" item-text="name" item-value="id"
                        label="Choisir le(s) domaines" solo chips v-validate="'required'"
                        :error-messages="errors.collect('domaine')" data-vv-name="domaine" required></v-select>
                    </div>
                    <div class="form-field">
                      <label for="">Adresse physique</label>
                      <v-textarea v-model="form.address" placeholder="Ex: 02393 Rue Boniface Natitingou" name="address"
                        solo v-validate="'required'" :error-messages="errors.collect('address')" data-vv-name="address"
                        required></v-textarea>
                    </div>
                  </v-tab-item>

                  <!--  -->
                  <v-tab-item>
                    <div class="form-field">
                      <label for="">Pays</label>
                      <v-select v-model="form.country_id" :items="countries" item-text="name" item-value="id"
                        item-key="id" label="Choisir le pays" solo v-validate="'required'"
                        :error-messages="errors.collect('pays')" data-vv-name="pays" required></v-select>
                    </div>
                    <div class="form-field">
                      <label for="">Departement</label>
                      <v-select v-model="form.department_id" :items="departments" item-text="name" item-value="id"
                        item-key="id" label="Choisir le departement" solo @change="loadMunicipalities()"
                        v-validate="'required'" :error-messages="errors.collect('departement')"
                        data-vv-name="departement" required></v-select>
                    </div>
                    <div class="form-field">
                      <label for="">Commune</label>
                      <v-select v-model="form.municipality_id" :items="filteredMunicipalities" item-text="name"
                        item-value="id" item-key="id" label="Choisir la commune" solo @change="loadDistricts()"
                        v-validate="'required'" :error-messages="errors.collect('commune')" data-vv-name="commune"
                        required></v-select>
                    </div>
                    <div class="form-field">
                      <label for="">Arrondissement</label>
                      <v-select v-model="form.district_id" :items="filteredDistricts" item-text="name" item-value="id"
                        item-key="id" label="Choisir l'arrondissement" solo @change="loadTowns()"
                        v-validate="'required'" :error-messages="errors.collect('arrondissement')"
                        data-vv-name="arrondissement" required></v-select>
                    </div>
                    <div class="form-field">
                      <label for="">Village</label>
                      <v-select v-model="form.town_id" :items="filteredTowns" item-text="name" item-value="id"
                        item-key="id" label="Choisir la ville/village" solo v-validate="'required'"
                        :error-messages="errors.collect('village')" data-vv-name="village" required></v-select>
                    </div>
                    <!-- Password -->
                    <div class="form-field">
                      <label for="">Mot de passe:</label>
                      <password-input ref="password" :form="form" :v-errors="errors" :hint="$t('password_length_hint')"
                        :value.sync="form.password" autocomplete="new-password" v-on:eye="eye = $event" name="password"
                        v-validate="'required|min:8'" :error-messages="errors.collect('password')"
                        data-vv-name="password"></password-input>
                    </div>

                    <div class="form-field">
                      <vue-recaptcha :sitekey="recaptchaKey"></vue-recaptcha>
                    </div>
                  </v-tab-item>
                </v-tabs>
                <div class="tab-indicator">
                  <span class="px-1" @click.prevent="tab = index" small icon v-for="(i, index) in 2"
                    :key="index"><v-icon color="primary" size="15px">{{
                      getIndicatorIcon(index)
                    }}</v-icon></span>
                </div>
                <div class="form-actions mt-5">
                  <v-btn @click.prevent="nextTab" rounded color="primary" v-if="tab == 0">Suivant <v-icon
                      right>mdi-menu-right</v-icon>
                  </v-btn>
                  <v-btn rounded @click.prevent="tab -= 1" class="mr-5" outlined color="primary"
                    v-if="tab > 0">Précédant
                    <v-icon right>mdi-menu-left</v-icon>
                  </v-btn>
                  <v-btn v-if="tab > 0" rounded color="primary" @click.prevent="register">S'inscrire</v-btn>
                  <!-- <submit-button v-if="tab > 0" :form="form" label="S'inscrire"></submit-button> -->
                </div>
              </v-flex>
            </v-layout>
            <v-container fluid grid-list-md>
              <v-layout row text-center>
                <v-flex fill-height mb-2>
                  <img src="/img/pays_bas_tiny.png" alt="Pays bas logo" width="100" height="38" />
                </v-flex>
              </v-layout>
              <v-layout row align-center justify-space-between>
                <div xs12 sm4 md4>
                  <img src="/img/ifdc.png" alt="logos partenaires" width="115" height="80" />
                </div>
                <div xs12 sm4 md4>
                  <img src="/img/care.png" alt="logos partenaires" width="100" height="80" />
                </div>
                <div xs12 sm4 md4>
                  <img src="/img/kit.png" alt="logos partenaires" width="80" height="70" />
                </div>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions> </v-card-actions>
        </v-card>
      </form>
    </v-flex>
  </v-layout>
</template>

<script>
import Form from "vform";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "register-view",
  layout: "default",
  components: {
    VueRecaptcha,
  },
  metaInfo() {
    return { title: this.$t("register") };
  },

  data: () => ({
    tab: 0,
    filterCount: 0,
    recaptchaKey: "6LeKQLYUAAAAADbu73VZdbFdu61vJc4E4UNtdZJ5",
    form: new Form({
      username: "",
      email: "",
      password: "",
      password_confirmation: "",
      first_name: "",
      last_name: "",
      phone: "",
      country_id: "",
      domain_id: "",
      department_id: "",
      district_id: "",
      town_id: "",
      address: "",
      phone: "",
      token: "a0593960-cd6f-11e9-82bc-4fa388741b4c",
      g_recaptcha_response: "",
    }),
    items: [],
    eye: true,
    errorsDictionnary: {
      stepFields: {
        step1: [
          "username",
          "email",
          "first_name",
          "last_name",
          "phone",
          "domaine",
          "address",
        ],
        step2: [
          "pays",
          "departement",
          "commune",
          "arrondissement",
          "village",
          "password",
        ],
      },
    },
  }),
  created() {
    this.token = this.$route.params.token;
    axios
      .get("/api/invitation/check/" + this.token)
      .then((response) => {
        this.form.email = response.data.email;
        this.form.token = this.token;
      })
      .catch((error) => console.log(error));

    this.fetchCountries();
    this.fetchDepartments();
    this.fetchDomains();
    this.fetchMunicipalities();
    this.fetchDistricts();
    this.fetchTowns();
  },
  computed: {
    filteredMunicipalities: {
      // getter
      get: function () {
        return this.$store.getters.filteredData;
      },
      // setter
      set: function (newValue) {
        this.$store.commit("filterMunicipalities", newValue);
      },
    },
    filteredDistricts: {
      // getter
      get: function () {
        return this.$store.getters.filteredDistrictsData;
      },
      // setter
      set: function (newValue) {
        this.$store.commit("filterDistricts", newValue);
      },
    },
    filteredTowns: {
      // getter
      get: function () {
        return this.$store.getters.filteredTownsData;
      },
      // setter
      set: function (newValue) {
        this.$store.commit("filterTowns", newValue);
      },
    },
    ...mapGetters(["countries", "departments", "domains", "districts"]),
  },
  methods: {
    ...mapActions([
      "fetchCountries",
      "fetchDepartments",
      "fetchMunicipalities",
      "fetchDistricts",
      "fetchDomains",
      "fetchTowns",
    ]),
    async nextTab() {
      let completed = await this.stepCompleted(this.tab + 1)
      // let completed = true;
      if (completed) {
        this.tab += 1;
      }
    },
    async stepCompleted(step) {
      let stepField = this.errorsDictionnary.stepFields["step" + step];
      let validations = [];
      for (let index = 0; index < stepField.length; index++) {
        const field = stepField[index];

        validations.push(this.$validator.validate(field));
      }
      const results = Promise.all([...validations]);

      const areValid = (await results).every((isValid) => isValid);

      return areValid;
    },
    getIndicatorIcon(index) {
      return this.tab !== index ? "mdi-circle-outline" : "mdi-circle";
    },
    loadMunicipalities() {
      this.filterCount = 1;
      this.filteredMunicipalities = this.$store.getters.getMunicipalityByDepartmentId(
        this.form.department_id
      );
    },
    loadDistricts() {
      this.filterCount = 1;
      this.filteredDistricts = this.$store.getters.getDistrictByMunicipalityId(
        this.form.municipality_id
      );
    },
    loadTowns() {
      this.filterCount = 1;
      this.filteredTowns = this.$store.getters.getTownByDistrictId(
        this.form.district_id
      );
    },
    async register() {
      let completed = await this.stepCompleted(2)
      if (completed) {
        // Register the user.
        try {
          await this.form.post("/api/invitation/accept");

          // Log in the user.
          const { data } = await this.form.post("/api/auth/login");

          // Save the token.
          this.$store.dispatch("saveToken", { token: data.access_token });

          // Fetch the user.
          await this.$store.dispatch("fetchUser");

          // Redirect home.
          this.$router.push({ name: "overview" });
        } catch (error) {
          this.$store.dispatch("responseMessage", {
            type: "red",
            text: error.response.data.errors.message,
          });
          this.form.reset();
        }
      }

    },
  },
  beforeDestroy() {
    this.$validator.pause();
  },
};
</script>


<style scoped>
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #78b943;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/register.vue